import React from 'react';
import RestInputItem from 'components/RestInput/RestInputItem';
import { Select, Input } from 'antd';

const CareerRequestsForm = props => (
  <div {...props}>
    <RestInputItem source="fullName" header="careerRequests.fullName" />
    <RestInputItem source="desiredField" header="careerRequests.desiredField" />
    <RestInputItem source="phoneNumber" header="careerRequests.phoneNumber" />
    <RestInputItem source="email" header="careerRequests.email" />
    <RestInputItem
      source="description"
      header="careerRequests.description"
      ContentComponent={Input.TextArea}
      rows={4}
    />
    <RestInputItem source="cvUrl" header="careerRequests.cvUrl" />
    <RestInputItem
      source="status"
      header="careerRequests.status"
      ContentComponent={Select}
      valueProp="value"
    >
      <Select.Option value="pending">Pending</Select.Option>
      <Select.Option value="contacted">Contacted</Select.Option>
      <Select.Option value="in_progress">In Progress</Select.Option>
      <Select.Option value="completed">Completed</Select.Option>
      <Select.Option value="rejected">Rejected</Select.Option>
    </RestInputItem>
    <RestInputItem
      source="adminNotes"
      header="careerRequests.adminNotes"
      ContentComponent={Input.TextArea}
      rows={4}
    />
  </div>
);

CareerRequestsForm.propTypes = {};

export default CareerRequestsForm;
